import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'home-fitness-content-manager',
  templateUrl: './home-fitness-content-manager.component.html',
  styleUrls: ['./home-fitness-content-manager.component.scss']
})
export class HomeFitnessContentManagerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
